import React, { useMemo } from 'react';
import { ReactComponent as NotificationSvg } from "../../../../assets/svg/notification.svg";
import {
  isMobile
} from "../../../../shared/helpers";
import { store } from "../../../../stores/store";
import { Button, ButtonSize, ButtonStyles } from "../../../Button";

import {
  addIndex,
  map,
  path,
  pipe,
} from "ramda";
import {iDeviceDetails, iDevicePing, iFullStoreState, iTrip, Units} from "../../../../shared/interfaces";
import { withPrevPair } from '../../../../shared/ramda';
import { useLocalStorage } from "../../../../stores/reducers/general-reducers";
import { CustomDropdown } from '../../../elements/CustomDropdown/CustomDropdown';
import { iHiddenReportData } from "../vis-report-data";
import styles from "./RenderStaticReport.module.scss";
import RenderTripReportData from './RenderTripReportData';
import DeviceWithoutTravel from "../DeviceWithoutTravel/DeviceWithoutTravel";
import { shallowEqual, useSelector } from "react-redux";

const TripRow = React.memo(
  ({ trip, hasTripForDevice, records, deviceUnits, deviceTimezone, showAllRoutes, deviceId, showTrip }: any) => {
    const device = useSelector<iFullStoreState, iDeviceDetails | undefined>(
      state => state.devicesData.devicesDetails.get(trip.current.device),
      shallowEqual
    );

    const deviceLastPing = useSelector<iFullStoreState, iDevicePing | undefined | null>(
      state => device ? state.devicesData.devicesLastPing.get(device.id) : undefined,
      (l, r) => l?.pointId === r?.pointId
    );

    const lastLocation = useMemo(() => {
      if (
        deviceLastPing?.address &&
        (deviceLastPing.address.street ||
          deviceLastPing.address.state ||
          deviceLastPing.address.city ||
          deviceLastPing.address.zip)
      ) {
        return `${deviceLastPing.address.street || ''} ${deviceLastPing.address.state || ''} ${deviceLastPing.address.city || ''} ${deviceLastPing.address.zip || ''}`
          .replace(/\s+/g, ' ')
          .trim();
      }
      return 'No last ping';
    }, [deviceLastPing]);

    return hasTripForDevice ? (
      <RenderTripReportData
        trip={trip}
        showTrip={showTrip}
        records={records}
        deviceUnits={deviceUnits}
        deviceTimezone={deviceTimezone}
        showAllRoutes={showAllRoutes}
        deviceId={deviceId}
      />
    ) : (
      <DeviceWithoutTravel
        message='No Trips available for the selected range'
        lastLocation={lastLocation}
      />
    );
  }
);

const RenderPaginatedReport = ({
  records,
  showAllTrips,
  hideAllTrips,
  showTrip,
  staticNextDevice,
  staticPreviousDevice,
  staticCurrentDeviceIdx,
  staticDevicesLength,
  deviceNameOptions,
  currentRecordKey,
  currentRecordsKeys,
  setCurrentRecordsKeys,
  setCurrentRecordKey
}) => {
  const deviceId = pipe(path([0, "device"]))(records);
  const state = store.getState();
  const ids = state.devicesTripsPoints.getIn([deviceId, "reportTripsIds"]) as Map<string, any> | undefined;
  const reportTripsIds = ids ? [...ids.values()] : [];
  const showAllRoutes = reportTripsIds.length
    ? reportTripsIds.some((item) => item)
    : false;
  const deviceUnits = state.devicesData.devicesDetails.getIn([deviceId, "units"], Units.miles) as Units;
  const deviceTimezone = state.devicesData.devicesDetails.getIn([deviceId, "timezone"], "EST") as string
  const [hiddenFields] = useLocalStorage<iHiddenReportData>(
    "hidden-report-data:static",
    {}
  );

  const areas = ["time", "person", "fuel", "voltage", "speed", "posted", "consumption", "location", "coordinates", "label"];
  const widthPerAreas = {
    time: 64,
    person: 142,
    fuel: 64,
    voltage: 72,
    speed: 64,
    posted: 72,
    consumption: 64,
    location: 150,
    coordinates: 150,
    label: 150,
  };
  const gridTemplateAreas = areas.filter((area) => !hiddenFields[area]);

  const outTable = addIndex(map);

  const getRecordsWithPrevPair = withPrevPair(records);

    const getTripOrPointData = outTable((tripOrPoint) => {
      const trip: {
        current: iTrip;
        previous: iTrip;
      } = tripOrPoint;
    //   return reportType === "travel" ? trip : points;

    return trip;
    });

    const reportData = getTripOrPointData(getRecordsWithPrevPair);

  const hasTripForDevice = reportData.some(
      trip => trip.current.device === deviceId && trip.current.tripId !== null
  );

  return (
    <div>
      <div
        className={`d-flex justify-content-between ${(isMobile || window["cordova"]) && "align-items-center"
        } ${styles.ReportHeader}`}
      >
        <div className={styles.ReportHeaderDevicePaginate}>
          {/* <button
            disabled={staticCurrentDeviceIdx === 0}
            onClick={staticPreviousDevice}
            className={styles.paginateBtn}
          >
            <PaginatePrevious
              style={{pointerEvents: 'none'}}
              className={styles.chevronLeft}
            />
          </button> */}
          <CustomDropdown
            options={deviceNameOptions}
            defaultValue={currentRecordKey}
            onChange={(selectedKey) => {
                const updatedRecords = currentRecordsKeys.map(record => ({
                    ...record,
                    isActive: record.key === selectedKey,
                }));

                setCurrentRecordsKeys(updatedRecords);
                setCurrentRecordKey(selectedKey);
            }}
         />
          {/* <button
            disabled={(staticCurrentDeviceIdx >= staticDevicesLength - 1) || staticDevicesLength === 0}
            onClick={staticNextDevice}
            className={styles.paginateBtn}
          >
            <PaginateNext
              style={{pointerEvents: 'none'}}
            />
          </button> */}
        </div>
        <div className={styles.ReportHeaderBtns}>
          <Button
            className="but but-toggle but-24px"
            styleType={ButtonStyles.GRAY_INACTIVE}
            style={
              isMobile || window["cordova"] ? {height: "max-content"} : {}
            }
            size={ButtonSize.XSM}
          >
            <NotificationSvg
              className={isMobile || window["cordova"] ? "icon-smd" : "icon-sm"}
            />
          </Button>
          {/* <Button
            className={`but but-toggle but-24px ${
              showAllRoutes ? "active" : ""
            }`}
            styleType={
              showAllRoutes
                ? ButtonStyles.BLACK_WHITE
                : ButtonStyles.GRAY_INACTIVE
            }
            style={
              isMobile || window["cordova"] ? {height: "max-content"} : {}
            }
            size={ButtonSize.XSM}
            onClick={showAllRoutes ? hideAllTrips : showAllTrips}
          >
            <MapPointerSvg
              className={isMobile || window["cordova"] ? "icon-smd" : "icon-sm"}
            />
          </Button> */}
        </div>
      </div>
      {reportData.map((trip, idx) => (
          <div className="report-table-wraper" key={trip.current.tripId || `no-trip-${trip.current.device}-${idx}`}>
            <TripRow
                trip={trip}
                hasTripForDevice={hasTripForDevice}
                records={records}
                deviceUnits={deviceUnits}
                deviceTimezone={deviceTimezone}
                showAllRoutes={showAllRoutes}
                deviceId={deviceId}
                showTrip={showTrip}
            />
          </div>
      ))}
    </div>
  )
}

export default RenderPaginatedReport;
